module.exports = __webpack_public_path__ + "img/6-3.4744fd3e.png";